import { defineComponent, ref } from 'vue-demi';
import { onClickOutside } from '@vueuse/core';
import { s as script$d } from './OrFloating-00617713.js';
import { s as script$b } from './OrLoader-d5a5b426.js';
import { s as script$9 } from './OrIcon-22d7aeff.js';
import { resolveComponent, openBlock, createElementBlock, normalizeClass, createElementVNode, createVNode, toDisplayString, Fragment, createTextVNode, createCommentVNode, createBlock, renderList, renderSlot, withCtx, normalizeProps, guardReactiveProps } from 'vue';
import { s as styleInject } from './style-inject.es-4c6f2515.js';
import { s as script$a } from './OrCheckbox-9d30d1d2.js';
import { i as isEmpty } from './isString-cf957a95.js';
import keyBy from 'lodash/keyBy';
import { s as script$c } from './OrChip-354bd93f.js';
import './OrChips-24f72916.js';
import { s as script$e } from './OrLabel-a7d99df4.js';
import { s as script$f } from './OrError-f90296db.js';

const DEFAULT_TEXT = {
  SEARCH_PLACEHOLDER: 'Search',
  SELECT_OPTION_PLACEHOLDER: 'Select option',
  NO_RESULTS_TITLE: 'No results',
  NO_RESULTS_START: 'We couldn\'t find ',
  NO_RESULTS_END: '.',
  UPDATE_SEARCH: 'Please, update your search criteria.'
};
const OR_SELECT_OPTIONS_PROP = {
  type: Array,
  default: () => []
};
const OR_SELECT_SEARCH_OPTIONS_PROP = {
  type: Array,
  default: undefined
};
const OR_SELECT_VALUE_PROP = {
  type: [String, Array, Number],
  default: undefined
};
const OR_SELECT_PLACEHOLDER_PROP = {
  type: String,
  default: () => DEFAULT_TEXT.SELECT_OPTION_PLACEHOLDER
};
const COMMON_STRING_PROP = {
  type: String,
  default: ''
};
const SEARCH_OPTIONS_FUNCTION_PROP = {
  type: Function,
  default: undefined
};
const OR_SELECT_NO_RESULTS_TITLE_PROP = {
  type: String,
  default: () => DEFAULT_TEXT.NO_RESULTS_TITLE
};
const OR_SELECT_NO_RESULTS_START_TEXT_PROP = {
  type: String,
  default: () => DEFAULT_TEXT.NO_RESULTS_START
};
const OR_SELECT_NO_RESULTS_END_TEXT_PROP = {
  type: String,
  default: () => DEFAULT_TEXT.NO_RESULTS_END
};
const OR_SELECT_UPDATE_SEARCH_TEXT_PROP = {
  type: String,
  default: () => DEFAULT_TEXT.UPDATE_SEARCH
};

var script$8 = defineComponent({
  name: 'OrSelectSearchOptions',
  components: {
    OrIcon: script$9
  },
  props: {
    isTop: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['search-change'],
  data() {
    return {
      search: '',
      placeholder: DEFAULT_TEXT.SEARCH_PLACEHOLDER
    };
  },
  computed: {
    icon() {
      return this.search ? 'close' : 'search';
    }
  },
  methods: {
    handleSearchChange(search) {
      this.search = search;
      this.$emit('search-change', search);
    }
  }
});

const _hoisted_1$5 = ["value", "placeholder"];
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_icon = resolveComponent("or-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["or-select-search-options", {
      'top': _ctx.isTop
    }])
  }, [createElementVNode("input", {
    class: "or-select-search-options-input",
    value: _ctx.search,
    placeholder: _ctx.placeholder,
    onInput: _cache[0] || (_cache[0] = $event => _ctx.handleSearchChange($event.target.value))
  }, null, 40 /* PROPS, NEED_HYDRATION */, _hoisted_1$5), createElementVNode("span", {
    class: "or-select-search-options-button",
    onClick: _cache[1] || (_cache[1] = $event => _ctx.handleSearchChange(''))
  }, [createVNode(_component_or_icon, {
    icon: _ctx.icon
  }, null, 8 /* PROPS */, ["icon"])])], 2 /* CLASS */);
}

var css_248z$8 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-2f836793 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-2f836793 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-select-search-options[data-v-2f836793] {\n  display: flex;\n  flex: 0 0 auto;\n  align-items: center;\n  height: 2.1875rem;\n  padding: 0 0.5rem;\n}\n.or-select-search-options[data-v-2f836793]:not(.top) {\n  border-bottom: 1px solid var(--c-neutral-2);\n}\n.or-select-search-options.top[data-v-2f836793] {\n  border-top: 1px solid var(--c-neutral-2);\n}\n.or-select-search-options-input[data-v-2f836793] {\n  flex: 1 1 100%;\n  min-width: 0;\n  height: 100%;\n  background: transparent;\n  border: none;\n  outline: none;\n}\n.or-select-search-options-button[data-v-2f836793] {\n  display: flex;\n  padding: 0.125rem;\n  margin-left: 0.5rem;\n  cursor: pointer;\n}\n.or-select-search-options-button[data-v-2f836793] .or-icon {\n  font-size: 1rem;\n  color: var(--c-neutral-4);\n}";
styleInject(css_248z$8);

script$8.render = render$8;
script$8.__scopeId = "data-v-2f836793";
script$8.__file = "src/components/or-select/partials/OrSelectSearchOptions.vue";

/** TODO: Use text management library! */
var script$7 = defineComponent({
  name: 'OrSelectContentEmpty',
  props: {
    search: {
      type: String,
      default: ''
    },
    noResultsTitle: OR_SELECT_NO_RESULTS_TITLE_PROP,
    noResultsStartText: OR_SELECT_NO_RESULTS_START_TEXT_PROP,
    noResultsEndText: OR_SELECT_NO_RESULTS_END_TEXT_PROP,
    updateSearchText: OR_SELECT_UPDATE_SEARCH_TEXT_PROP
  }
});

const _hoisted_1$4 = {
  class: "or-select-content-empty"
};
const _hoisted_2$1 = {
  class: "or-select-content-empty-title"
};
const _hoisted_3$1 = {
  class: "or-select-content-empty-description"
};
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$4, [createElementVNode("div", _hoisted_2$1, toDisplayString(_ctx.noResultsTitle), 1 /* TEXT */), _ctx.search ? (openBlock(), createElementBlock(Fragment, {
    key: 0
  }, [createElementVNode("div", _hoisted_3$1, [createTextVNode(toDisplayString(_ctx.noResultsStartText), 1 /* TEXT */), createElementVNode("strong", null, toDisplayString(_ctx.search), 1 /* TEXT */), createTextVNode(toDisplayString(_ctx.noResultsEndText), 1 /* TEXT */)]), createTextVNode(" " + toDisplayString(_ctx.updateSearchText), 1 /* TEXT */)], 64 /* STABLE_FRAGMENT */)) : createCommentVNode("v-if", true)]);
}

var css_248z$7 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-26c01027 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-26c01027 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-select-content-empty[data-v-26c01027] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 10.625rem;\n}\n.or-select-content-empty-title[data-v-26c01027] {\n  font-weight: var(--fw-1);\n}\n.or-select-content-empty-description[data-v-26c01027] {\n  margin-top: 0.5rem;\n}";
styleInject(css_248z$7);

script$7.render = render$7;
script$7.__scopeId = "data-v-26c01027";
script$7.__file = "src/components/or-select/partials/OrSelectContentEmpty.vue";

var script$6 = defineComponent({
  name: 'OrSelectOption',
  components: {
    OrCheckbox: script$a
  },
  props: {
    option: {
      type: Object,
      required: true
    },
    isActive: Boolean,
    isCheckbox: Boolean
  },
  emits: ['select-option'],
  computed: {
    optionLabel() {
      var _a;
      return String((_a = this.option.label) !== null && _a !== void 0 ? _a : this.option.value);
    }
  }
});

const _hoisted_1$3 = {
  key: 0,
  class: "or-select-option-content"
};
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_checkbox = resolveComponent("or-checkbox");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["or-select-option", {
      active: _ctx.isActive,
      checkbox: _ctx.isCheckbox
    }]),
    onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('select-option'))
  }, [!_ctx.isCheckbox ? (openBlock(), createElementBlock("span", _hoisted_1$3, toDisplayString(_ctx.optionLabel), 1 /* TEXT */)) : createCommentVNode("v-if", true), _ctx.isCheckbox ? (openBlock(), createBlock(_component_or_checkbox, {
    key: 1,
    label: _ctx.optionLabel,
    "model-value": _ctx.isActive
  }, null, 8 /* PROPS */, ["label", "model-value"])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z$6 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-60e42408 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-60e42408 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-select-option[data-v-60e42408] {\n  display: flex;\n  align-items: center;\n  height: 2.125rem;\n  padding: 0 0.5rem;\n  cursor: pointer;\n}\n.or-select-option[data-v-60e42408]:hover {\n  background-color: var(--c-neutral-1);\n}\n.or-select-option.active[data-v-60e42408]:not(.checkbox) {\n  font-weight: var(--fw-1);\n  background-color: var(--c-neutral-2);\n}\n.or-select-option-content[data-v-60e42408],\n.or-select-option[data-v-60e42408] .or-checkbox--content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.or-select-option .or-checkbox[data-v-60e42408] {\n  overflow: hidden;\n}";
styleInject(css_248z$6);

script$6.render = render$6;
script$6.__scopeId = "data-v-60e42408";
script$6.__file = "src/components/or-select/partials/OrSelectOption.vue";

var script$5 = defineComponent({
  name: 'OrSelectContentOptions',
  components: {
    OrSelectOption: script$6
  },
  props: {
    value: OR_SELECT_VALUE_PROP,
    options: OR_SELECT_OPTIONS_PROP,
    isMultiSelect: Boolean
  },
  emits: ['select-option'],
  methods: {
    isActive(option) {
      return this.isMultiSelect ? (this.value || []).includes(option.value) : option.value === this.value;
    },
    /** Bind event and content here, so slot won't have to manage event name and payload */
    getOnSelectCallback(option) {
      return () => this.$emit('select-option', option);
    }
  }
});

const _hoisted_1$2 = {
  class: "or-select-content-options"
};
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_select_option = resolveComponent("or-select-option");
  return openBlock(), createElementBlock("div", _hoisted_1$2, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.options, option => {
    return openBlock(), createElementBlock("div", {
      key: option.value,
      class: "or-select-content-option-wrapper"
    }, [renderSlot(_ctx.$slots, "content-option", {
      option: option,
      isActive: _ctx.isActive(option),
      onSelect: _ctx.getOnSelectCallback(option)
    }, () => [createVNode(_component_or_select_option, {
      option: option,
      "is-active": _ctx.isActive(option),
      "is-checkbox": _ctx.isMultiSelect,
      onSelectOption: $event => _ctx.$emit('select-option', option)
    }, null, 8 /* PROPS */, ["option", "is-active", "is-checkbox", "onSelectOption"])])]);
  }), 128 /* KEYED_FRAGMENT */))]);
}

var css_248z$5 = ".or-select-content-options[data-v-5b1a5878] {\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n}";
styleInject(css_248z$5);

script$5.render = render$5;
script$5.__scopeId = "data-v-5b1a5878";
script$5.__file = "src/components/or-select/partials/OrSelectContentOptions.vue";

var script$4 = defineComponent({
  name: 'OrSelectContent',
  components: {
    OrLoader: script$b,
    OrSelectSearchOptions: script$8,
    OrSelectContentEmpty: script$7,
    OrSelectContentOptions: script$5
  },
  props: {
    value: OR_SELECT_VALUE_PROP,
    options: OR_SELECT_OPTIONS_PROP,
    useSearch: Boolean,
    isTop: Boolean,
    isLoading: Boolean,
    isMultiSelect: Boolean,
    noResultsTitle: OR_SELECT_NO_RESULTS_TITLE_PROP,
    noResultsStartText: OR_SELECT_NO_RESULTS_START_TEXT_PROP,
    noResultsEndText: OR_SELECT_NO_RESULTS_END_TEXT_PROP,
    updateSearchText: OR_SELECT_UPDATE_SEARCH_TEXT_PROP
  },
  emits: ['search-change', 'select-option'],
  data() {
    return {
      search: ''
    };
  },
  computed: {
    showOptions() {
      return !this.isLoading && this.options.length > 0;
    },
    showEmptyResult() {
      return !this.isLoading && !this.options.length;
    }
  },
  methods: {
    handleSearchChange(search) {
      this.search = search;
      this.$emit('search-change', search);
    },
    handleSelectOption(option) {
      this.$emit('select-option', option);
    }
  }
});

function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_select_search_options = resolveComponent("or-select-search-options");
  const _component_or_loader = resolveComponent("or-loader");
  const _component_or_select_content_empty = resolveComponent("or-select-content-empty");
  const _component_or_select_content_options = resolveComponent("or-select-content-options");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["or-select-content", {
      'top': _ctx.isTop
    }])
  }, [_ctx.useSearch && !_ctx.isTop ? (openBlock(), createBlock(_component_or_select_search_options, {
    key: 0,
    onSearchChange: _ctx.handleSearchChange
  }, null, 8 /* PROPS */, ["onSearchChange"])) : createCommentVNode("v-if", true), createElementVNode("div", {
    class: normalizeClass(["or-select-content-main", {
      'center-content': _ctx.isLoading
    }])
  }, [_ctx.isLoading ? (openBlock(), createBlock(_component_or_loader, {
    key: 0
  })) : createCommentVNode("v-if", true), _ctx.showEmptyResult ? renderSlot(_ctx.$slots, "empty-options", {
    key: 1,
    search: _ctx.search
  }, () => [createVNode(_component_or_select_content_empty, {
    search: _ctx.search,
    "no-results-title": _ctx.noResultsTitle,
    "no-results-start-text": _ctx.noResultsStartText,
    "no-results-end-text": _ctx.noResultsEndText,
    "update-search-text": _ctx.updateSearchText
  }, null, 8 /* PROPS */, ["search", "no-results-title", "no-results-start-text", "no-results-end-text", "update-search-text"])]) : createCommentVNode("v-if", true), renderSlot(_ctx.$slots, "content-options", {
    onSelectOption: _ctx.handleSelectOption
  }, () => [_ctx.showOptions ? (openBlock(), createBlock(_component_or_select_content_options, {
    key: 0,
    value: _ctx.value,
    options: _ctx.options,
    "is-multi-select": _ctx.isMultiSelect,
    onSelectOption: _cache[0] || (_cache[0] = $event => _ctx.$emit('select-option', $event))
  }, {
    "content-option": withCtx(scope => [renderSlot(_ctx.$slots, "content-option", normalizeProps(guardReactiveProps(scope)))]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["value", "options", "is-multi-select"])) : createCommentVNode("v-if", true)])], 2 /* CLASS */), _ctx.useSearch && _ctx.isTop ? (openBlock(), createBlock(_component_or_select_search_options, {
    key: 1,
    "is-top": "",
    onSearchChange: _ctx.handleSearchChange
  }, null, 8 /* PROPS */, ["onSearchChange"])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z$4 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-87277314 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-87277314 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-select-content[data-v-87277314] {\n  /* Should fit up to 5 rows by default */\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background-color: var(--c-white);\n  border: 1px solid var(--c-neutral-2);\n}\n.or-select-content[data-v-87277314]:not(.top) {\n  border-bottom-right-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n  box-shadow: 0 0.125rem 0.5rem 0 rgba(0, 0, 0, 0.1);\n}\n.or-select-content.top[data-v-87277314] {\n  border-top-left-radius: 0.25rem;\n  border-top-right-radius: 0.25rem;\n  box-shadow: 0 -0.125rem 0.5rem 0 rgba(0, 0, 0, 0.1);\n}\n.or-select-content-main[data-v-87277314] {\n  display: flex;\n  flex: 1 1 100%;\n  flex-direction: column;\n  max-height: 10.625rem;\n  overflow-y: auto;\n}\n.or-select-content-main.center-content[data-v-87277314] {\n  flex: 0 0 10.625rem;\n  align-items: center;\n  justify-content: center;\n}";
styleInject(css_248z$4);

script$4.render = render$4;
script$4.__scopeId = "data-v-87277314";
script$4.__file = "src/components/or-select/partials/OrSelectContent.vue";

var script$3 = defineComponent({
  name: 'OrSelectInputValue',
  components: {
    OrChip: script$c
  },
  props: {
    value: OR_SELECT_VALUE_PROP,
    options: OR_SELECT_SEARCH_OPTIONS_PROP,
    isMultiSelect: Boolean,
    isDisabled: Boolean
  },
  emits: ['delete-value'],
  computed: {
    optionsByKey() {
      return keyBy(this.options, 'value');
    },
    states() {
      return {
        'simple-value': !this.isMultiSelect,
        'multi-value': this.isMultiSelect
      };
    }
  },
  methods: {
    getOptionLabel(optionId) {
      var _a;
      const option = this.optionsByKey[optionId];
      return String(option ? (_a = option.label) !== null && _a !== void 0 ? _a : option.value : optionId);
    },
    /** Prevent content toggle event on chips, since they have their own control elements */
    handleInputValueClick(event) {
      const inputValueElement = this.$refs['input-value'];
      const inputValueTextElement = this.$refs['input-value-text'];
      const target = event.target;
      if (target !== inputValueElement && target !== inputValueTextElement) {
        event.stopPropagation();
      }
    }
  }
});

function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_chip = resolveComponent("or-chip");
  return openBlock(), createElementBlock("div", {
    ref: "input-value",
    class: normalizeClass(["or-select-input-value", _ctx.states]),
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleInputValueClick && _ctx.handleInputValueClick(...args))
  }, [!_ctx.isMultiSelect ? (openBlock(), createElementBlock("div", {
    key: 0,
    ref: "input-value-text",
    class: "or-select-input-value-text"
  }, toDisplayString(_ctx.getOptionLabel(_ctx.value)), 513 /* TEXT, NEED_PATCH */)) : createCommentVNode("v-if", true), _ctx.isMultiSelect ? (openBlock(true), createElementBlock(Fragment, {
    key: 1
  }, renderList(_ctx.value, valueItem => {
    return openBlock(), createBlock(_component_or_chip, {
      key: valueItem,
      content: _ctx.getOptionLabel(valueItem),
      "is-disabled": _ctx.isDisabled,
      onDelete: $event => _ctx.$emit('delete-value', valueItem)
    }, null, 8 /* PROPS */, ["content", "is-disabled", "onDelete"]);
  }), 128 /* KEYED_FRAGMENT */)) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z$3 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-7e5504da {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-7e5504da {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-select-input-value[data-v-7e5504da] {\n  display: flex;\n  flex: 1 1 100%;\n  overflow: hidden;\n}\n.or-select-input-value.simple-value[data-v-7e5504da] {\n  align-items: center;\n}\n.or-select-input-value-text[data-v-7e5504da] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.or-select-input-value.multi-value[data-v-7e5504da] {\n  flex-wrap: wrap;\n  padding: 0.125rem 0;\n}\n.or-select-input-value.multi-value .or-chip[data-v-7e5504da] {\n  margin: 0.125rem;\n}\n.or-select-input-value.multi-value .or-chip[data-v-7e5504da]:not(.disabled) {\n  cursor: default;\n}";
styleInject(css_248z$3);

script$3.render = render$3;
script$3.__scopeId = "data-v-7e5504da";
script$3.__file = "src/components/or-select/partials/OrSelectInputValue.vue";

var script$2 = defineComponent({
  name: 'OrSelectInput',
  components: {
    OrIcon: script$9,
    OrSelectInputValue: script$3
  },
  props: {
    value: OR_SELECT_VALUE_PROP,
    options: OR_SELECT_OPTIONS_PROP,
    placeholder: OR_SELECT_PLACEHOLDER_PROP,
    isOpen: Boolean,
    isMultiSelect: Boolean,
    isTop: Boolean,
    isDisabled: Boolean,
    isInvalid: Boolean
  },
  emits: ['toggle-content', 'delete-value'],
  computed: {
    icon() {
      return this.isOpen ? 'arrow_drop_up' : 'arrow_drop_down';
    },
    states() {
      return {
        open: this.isOpen,
        error: this.isInvalid,
        disabled: this.isDisabled,
        multiselect: this.isMultiSelect,
        top: this.isTop
      };
    },
    isEmptyValue() {
      return typeof this.value === 'number' ? false : isEmpty(this.value);
    }
  },
  methods: {
    handleToggleContent() {
      if (!this.isDisabled) {
        this.$emit('toggle-content');
      }
    }
  }
});

const _hoisted_1$1 = {
  key: 0,
  class: "or-select-input-placeholder"
};
const _hoisted_2 = {
  class: "or-select-input-placeholder-text"
};
const _hoisted_3 = {
  class: "or-select-input-button"
};
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_select_input_value = resolveComponent("or-select-input-value");
  const _component_or_icon = resolveComponent("or-icon");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["or-select-input input-wrapper", _ctx.states]),
    onClick: _cache[1] || (_cache[1] = (...args) => _ctx.handleToggleContent && _ctx.handleToggleContent(...args))
  }, [_ctx.isEmptyValue ? (openBlock(), createElementBlock("div", _hoisted_1$1, [createElementVNode("span", _hoisted_2, toDisplayString(_ctx.placeholder), 1 /* TEXT */)])) : createCommentVNode("v-if", true), !_ctx.isEmptyValue ? renderSlot(_ctx.$slots, "input-value", {
    key: 1,
    value: _ctx.value,
    options: _ctx.options
  }, () => [createVNode(_component_or_select_input_value, {
    value: _ctx.value,
    options: _ctx.options,
    "is-multi-select": _ctx.isMultiSelect,
    "is-disabled": _ctx.isDisabled,
    onDeleteValue: _cache[0] || (_cache[0] = $event => _ctx.$emit('delete-value', $event))
  }, null, 8 /* PROPS */, ["value", "options", "is-multi-select", "is-disabled"])]) : createCommentVNode("v-if", true), createElementVNode("div", _hoisted_3, [createVNode(_component_or_icon, {
    icon: _ctx.icon
  }, null, 8 /* PROPS */, ["icon"])])], 2 /* CLASS */);
}

var css_248z$2 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-d093e2f2 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-d093e2f2 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-select-input[data-v-d093e2f2] {\n  display: flex;\n  padding: 0 0.5rem;\n  cursor: pointer;\n}\n.or-select-input.input-wrapper[data-v-d093e2f2] {\n  min-height: 2.25rem;\n  background-color: var(--c-neutral-1);\n  border: 1px solid var(--c-neutral-2);\n  border-radius: 0.25rem;\n}\n.or-select-input.input-wrapper.error[data-v-d093e2f2] {\n  border-color: var(--c-error);\n}\n.or-select-input[data-v-d093e2f2]:hover:not(.disabled), .or-select-input.open[data-v-d093e2f2] {\n  background-color: var(--c-white);\n}\n.or-select-input.open[data-v-d093e2f2] {\n  border-color: var(--c-neutral-2);\n}\n.or-select-input.open[data-v-d093e2f2]:not(.top) {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.or-select-input.open.top[data-v-d093e2f2] {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.or-select-input.disabled[data-v-d093e2f2] {\n  cursor: not-allowed;\n}\n.or-select-input.disabled[data-v-d093e2f2]:not(.multiselect) {\n  background-color: var(--c-neutral-1-darken-5);\n}\n.or-select-input-placeholder[data-v-d093e2f2] {\n  display: flex;\n  align-items: center;\n  overflow: hidden;\n  color: var(--c-neutral-4);\n  user-select: none;\n}\n.or-select-input-placeholder-text[data-v-d093e2f2] {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.or-select-input-button[data-v-d093e2f2] {\n  display: flex;\n  align-items: center;\n  height: 2.125rem;\n  margin-left: auto;\n}\n.or-select-input-button[data-v-d093e2f2] .or-icon {\n  margin-left: 0.5rem;\n}";
styleInject(css_248z$2);

script$2.render = render$2;
script$2.__scopeId = "data-v-d093e2f2";
script$2.__file = "src/components/or-select/partials/OrSelectInput.vue";

var script$1 = defineComponent({
  name: 'OrSelect',
  components: {
    OrSelectInput: script$2,
    OrSelectContent: script$4,
    OrFloating: script$d
  },
  props: {
    value: OR_SELECT_VALUE_PROP,
    options: OR_SELECT_OPTIONS_PROP,
    placeholder: OR_SELECT_PLACEHOLDER_PROP,
    contentOptions: OR_SELECT_OPTIONS_PROP,
    useSearch: Boolean,
    isMultiSelect: Boolean,
    isLoading: Boolean,
    isDisabled: Boolean,
    isInvalid: Boolean,
    noResultsTitle: OR_SELECT_NO_RESULTS_TITLE_PROP,
    noResultsStartText: OR_SELECT_NO_RESULTS_START_TEXT_PROP,
    noResultsEndText: OR_SELECT_NO_RESULTS_END_TEXT_PROP,
    updateSearchText: OR_SELECT_UPDATE_SEARCH_TEXT_PROP,
    ignoreClickOutside: Boolean
  },
  emits: ['open', 'close', 'input', 'search-change'],
  setup(props) {
    const isOpen = ref(false);
    const root = ref();
    const content = ref(null);
    const floating = ref();
    onClickOutside(content, evt => {
      if (props.ignoreClickOutside) return;
      if (evt.composedPath().includes(root.value)) return;
      isOpen.value = false;
    });
    return {
      root,
      floating,
      content,
      isOpen
    };
  },
  computed: {
    isFlipped() {
      var _a, _b;
      return (_b = (_a = this.floating) === null || _a === void 0 ? void 0 : _a.isFlipped) !== null && _b !== void 0 ? _b : false;
    }
  },
  watch: {
    /* Closing dropdown should notify about search state reset */
    isOpen(isOpen) {
      const event = isOpen ? 'open' : 'close';
      this.$emit(event);
      if (!isOpen && this.useSearch) {
        this.$emit('search-change', '');
      }
    }
  },
  methods: {
    handleOptionSelect(option) {
      if (this.isMultiSelect) {
        const copy = [...this.value];
        const index = copy.findIndex(optionId => optionId === option.value);
        index !== -1 ? copy.splice(index, 1) : copy.push(option.value);
        this.$emit('input', copy);
      } else {
        this.$emit('input', option.value);
        this.isOpen = false;
      }
    },
    handleDeleteValue(optionId) {
      const value = [...this.value].filter(valueItem => valueItem !== optionId);
      this.$emit('input', value);
    }
  }
});

function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_select_input = resolveComponent("or-select-input");
  const _component_or_select_content = resolveComponent("or-select-content");
  const _component_or_floating = resolveComponent("or-floating");
  return openBlock(), createElementBlock("div", {
    ref: 'root',
    class: normalizeClass(["or-select-main", {
      open: _ctx.isOpen
    }])
  }, [createVNode(_component_or_select_input, {
    value: _ctx.value,
    options: _ctx.options,
    placeholder: _ctx.placeholder,
    "is-open": _ctx.isOpen,
    "is-multi-select": _ctx.isMultiSelect,
    "is-top": _ctx.isFlipped,
    "is-disabled": _ctx.isDisabled,
    "is-invalid": _ctx.isInvalid,
    onToggleContent: _cache[0] || (_cache[0] = $event => _ctx.isOpen = !_ctx.isOpen),
    onDeleteValue: _ctx.handleDeleteValue
  }, {
    "input-value": withCtx(scope => [renderSlot(_ctx.$slots, "input-value", normalizeProps(guardReactiveProps(scope)))]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["value", "options", "placeholder", "is-open", "is-multi-select", "is-top", "is-disabled", "is-invalid", "onDeleteValue"]), _ctx.isOpen ? (openBlock(), createBlock(_component_or_floating, {
    key: 0,
    ref: "floating",
    trigger: _ctx.root,
    placement: "bottom",
    "is-inheriting-width": "",
    "is-using-flip": "",
    "hide-strategy": "escaped",
    "z-index-offset": 10
  }, {
    default: withCtx(() => [createVNode(_component_or_select_content, {
      ref: "content",
      class: normalizeClass({
        'top': _ctx.isFlipped
      }),
      value: _ctx.value,
      options: _ctx.contentOptions,
      "use-search": _ctx.useSearch,
      "is-multi-select": _ctx.isMultiSelect,
      "is-loading": _ctx.isLoading,
      "is-top": _ctx.isFlipped,
      "no-results-title": _ctx.noResultsTitle,
      "no-results-start-text": _ctx.noResultsStartText,
      "no-results-end-text": _ctx.noResultsEndText,
      "update-search-text": _ctx.updateSearchText,
      onSelectOption: _ctx.handleOptionSelect,
      onSearchChange: _cache[1] || (_cache[1] = $event => _ctx.$emit('search-change', $event))
    }, {
      "empty-options": withCtx(scope => [renderSlot(_ctx.$slots, "empty-options", normalizeProps(guardReactiveProps(scope)))]),
      "content-option": withCtx(scope => [renderSlot(_ctx.$slots, "content-option", normalizeProps(guardReactiveProps(scope)))]),
      "content-options": withCtx(scope => [renderSlot(_ctx.$slots, "content-options", normalizeProps(guardReactiveProps(scope)))]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["class", "value", "options", "use-search", "is-multi-select", "is-loading", "is-top", "no-results-title", "no-results-start-text", "no-results-end-text", "update-search-text", "onSelectOption"])]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["trigger"])) : createCommentVNode("v-if", true)], 2 /* CLASS */);
}

var css_248z$1 = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-6101fbe8 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-6101fbe8 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-select-main[data-v-6101fbe8] {\n  position: relative;\n}\n.or-select-main .or-select-input[data-v-6101fbe8] {\n  position: relative;\n}\n.or-floating .or-select-content[data-v-6101fbe8] {\n  width: 100%;\n}\n.or-floating .or-select-content[data-v-6101fbe8]:not(.top) {\n  border-top: none;\n}\n.or-floating .or-select-content.top[data-v-6101fbe8] {\n  border-bottom: none;\n}";
styleInject(css_248z$1);

script$1.render = render$1;
script$1.__scopeId = "data-v-6101fbe8";
script$1.__file = "src/components/or-select/partials/OrSelectMain.vue";

var script = defineComponent({
  name: 'OrSelect',
  components: {
    OrSelectMain: script$1,
    OrLabel: script$e,
    OrError: script$f
  },
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    /** Values are displayed as is, when there are no matching options */
    modelValue: OR_SELECT_VALUE_PROP,
    /**
     * Options visible by default, when search options are empty.
     * In order to display labels for values, we need options that match them by ID.
     */
    options: OR_SELECT_OPTIONS_PROP,
    /**
     * User can override list of options visible in dropdown content,
     * for example when displaying search results.
     * Does't work when search function is provided.
     */
    searchOptions: OR_SELECT_SEARCH_OPTIONS_PROP,
    placeholder: OR_SELECT_PLACEHOLDER_PROP,
    label: COMMON_STRING_PROP,
    error: COMMON_STRING_PROP,
    /**
     * Enables search textbox, but does nothing by default.
     * User has either to listen to 'search-change' event, or provide search function.
     */
    useSearch: Boolean,
    isMultiSelect: Boolean,
    /** Ignored when search function is provided */
    isLoading: Boolean,
    isRequired: Boolean,
    isDisabled: Boolean,
    isInvalid: Boolean,
    ignoreClickOutside: Boolean,
    /**
     * When search function is provided, make component self-managed,
     * and ignore props like "searchOptions" and "isLoading".
     */
    searchFunction: SEARCH_OPTIONS_FUNCTION_PROP,
    noResultsTitle: OR_SELECT_NO_RESULTS_TITLE_PROP,
    noResultsStartText: OR_SELECT_NO_RESULTS_START_TEXT_PROP,
    noResultsEndText: OR_SELECT_NO_RESULTS_END_TEXT_PROP,
    updateSearchText: OR_SELECT_UPDATE_SEARCH_TEXT_PROP
  },
  emits: ['update:modelValue', 'open', 'close', 'search-change'],
  data() {
    return {
      localIsLoading: null,
      localContentOptions: null
    };
  },
  computed: {
    /**
     * When component is self-managed - local options override everything else.
     * Otherwise user can override options with a different list.
     */
    contentOptions() {
      return this.localContentOptions || this.searchOptions || this.options;
    },
    isContentLoading() {
      var _a;
      return (_a = this.localIsLoading) !== null && _a !== void 0 ? _a : this.isLoading;
    }
  },
  methods: {
    async handleSearchChange(search) {
      /* If component is managed by parent,
         simply emit event and let parent provide search results. */
      if (!this.searchFunction) {
        this.$emit('search-change', search);
        return;
      }
      /* Search function is applied to non-zero search values,
         since original options are displayed by default. */
      if (!search) {
        this.localContentOptions = this.options;
      }
      const searchResult = this.searchFunction({
        search
      });
      const searchResultPromise = searchResult;
      /* Automatically manage loading state, when search function return promise */
      if (!searchResultPromise.then) {
        this.localContentOptions = searchResult;
        return;
      }
      try {
        this.localIsLoading = true;
        this.localContentOptions = await searchResultPromise;
      } finally {
        this.localIsLoading = false;
      }
    }
  }
});

const _hoisted_1 = {
  class: "or-select"
};
function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_or_label = resolveComponent("or-label");
  const _component_or_select_main = resolveComponent("or-select-main");
  const _component_or_error = resolveComponent("or-error");
  return openBlock(), createElementBlock("div", _hoisted_1, [_ctx.label ? (openBlock(), createBlock(_component_or_label, {
    key: 0,
    label: _ctx.label,
    "is-required": _ctx.isRequired
  }, {
    append: withCtx(() => [renderSlot(_ctx.$slots, "label-append")]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["label", "is-required"])) : createCommentVNode("v-if", true), createVNode(_component_or_select_main, {
    value: _ctx.modelValue,
    options: _ctx.options,
    "content-options": _ctx.contentOptions,
    placeholder: _ctx.placeholder,
    "use-search": _ctx.useSearch,
    "is-multi-select": _ctx.isMultiSelect,
    "is-loading": _ctx.isContentLoading,
    "is-disabled": _ctx.isDisabled,
    "is-invalid": _ctx.isInvalid,
    "no-results-title": _ctx.noResultsTitle,
    "no-results-start-text": _ctx.noResultsStartText,
    "no-results-end-text": _ctx.noResultsEndText,
    "update-search-text": _ctx.updateSearchText,
    "ignore-click-outside": _ctx.ignoreClickOutside,
    onInput: _cache[0] || (_cache[0] = $event => _ctx.$emit('update:modelValue', $event)),
    onSearchChange: _ctx.handleSearchChange,
    onOpen: _cache[1] || (_cache[1] = $event => _ctx.$emit('open')),
    onClose: _cache[2] || (_cache[2] = $event => _ctx.$emit('close'))
  }, {
    "empty-options": withCtx(scope => [renderSlot(_ctx.$slots, "empty-options", normalizeProps(guardReactiveProps(scope)))]),
    "input-value": withCtx(scope => [renderSlot(_ctx.$slots, "input-value", normalizeProps(guardReactiveProps(scope)))]),
    "content-option": withCtx(scope => [renderSlot(_ctx.$slots, "content-option", normalizeProps(guardReactiveProps(scope)))]),
    "content-options": withCtx(scope => [renderSlot(_ctx.$slots, "content-options", normalizeProps(guardReactiveProps(scope)))]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["value", "options", "content-options", "placeholder", "use-search", "is-multi-select", "is-loading", "is-disabled", "is-invalid", "no-results-title", "no-results-start-text", "no-results-end-text", "update-search-text", "ignore-click-outside", "onSearchChange"]), _ctx.isInvalid ? (openBlock(), createBlock(_component_or_error, {
    key: 1,
    error: _ctx.error
  }, null, 8 /* PROPS */, ["error"])) : createCommentVNode("v-if", true)]);
}

var css_248z = "/**\n * A simple way to manage mobile breakpoints described in https://davidwalsh.name/write-media-queries-sass.\n * Can be further extended using following approach https://rimdev.io/making-media-query-mixins-with-sass/\n */\n@keyframes spinAround-5e370eb8 {\nfrom {\n    transform: rotate(0);\n}\nto {\n    transform: rotate(359deg);\n}\n}\n@keyframes fade-5e370eb8 {\nfrom {\n    opacity: 1;\n}\nto {\n    opacity: 0;\n}\n}\n.or-select[data-v-5e370eb8] {\n  display: flex;\n  flex-direction: column;\n  font-size: var(--fs-1);\n}\n.or-select .or-label[data-v-5e370eb8] {\n  margin-bottom: var(--s-1);\n}\n.or-select .or-error[data-v-5e370eb8] {\n  margin-top: var(--s-1);\n}";
styleInject(css_248z);

script.render = render;
script.__scopeId = "data-v-5e370eb8";
script.__file = "src/components/or-select/OrSelect.vue";

export { script as s };
